import classnames from "classnames";
import parse, { domToReact } from "html-react-parser";
import React from "react";

// Components
import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import ContactDetailsBox from "../contact-details-box/ContactDetailsBox";

// Utils
import { dispatchNewEvent } from "../../utils/analytics/trigger/analyticsTrigger";

// Styles
import styles from "./contact-us-manufacturer-solution.module.scss";

const numberClicked = number => {
  dispatchNewEvent("dataStateChange", {
    action: "contactUsDecisionSolution",
    type: window.jlData.page.decisionTree.refinement,
    solutionType: `manufacturer:${number.replace(/ /g, "")}`,
  });
};

function ContactUsManufacturerSolution({
  solution: { id, title, fields, hierarchyPosition },
  className,
  contactMethods = {},
}) {
  const locationOnPage = hierarchyPosition.join(" | ");
  return (
    <article className={classnames(styles.manufacturerSolution, className)} data-solution-id={id}>
      <h2 className={styles.manufacturerSolution__top}>Did you know...</h2>
      <div className={styles.manufacturerSolution__inner} data-test="solution-inner">
        {title && <h2 data-test="solution-name">{title}</h2>}
        {parse(fields.find(({ name }) => name === "content").content, {
          replace: ({ type, name: tagName, attribs: { ...nonStyleAttribs } = {}, children }) =>
            type === "tag" && nonStyleAttribs && React.createElement(tagName, nonStyleAttribs, domToReact(children)),
        })}
        <div className={styles["manufacturerSolution__manufacturer-details"]}>
          <h2>Contact {fields.find(({ name }) => name === "manufacturer").content} Technical Support</h2>
          <p>Please have the product with you when you call.</p>
          <div className={styles["manufacturerSolution__number-box"]}>
            <SecondaryButton
              tag="a"
              href={`tel:${fields.find(({ name }) => name === "manufacturerPhone").content.replace(/ /g, "")}`}
              onClick={() => numberClicked(id, fields.find(({ name }) => name === "manufacturerPhone").content)}
              className={styles["manufacturerSolution__number-button"]}
            >
              {fields.find(({ name }) => name === "manufacturerPhone").content}
            </SecondaryButton>
          </div>
        </div>
        <div className={styles.manufacturerSolution__separator}>
          <span>OR</span>
        </div>
        <ContactDetailsBox
          fields={fields.filter(({ name }) => ["phone", "chat"].includes(name))}
          title={"We’re here to help"}
          className={styles["manufacturerSolution__contact-details-manufacturer"]}
          solutionId={id}
          location={locationOnPage}
          contactMethods={contactMethods}
          viewContactDetails
          showGreyBackground
        />
      </div>
    </article>
  );
}

export default ContactUsManufacturerSolution;
